import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row } from "reactstrap";

function MediaDisplay(props) {
  const [url, setUrl] = useState("");
  const { displayName, fileName, resourceId } = props;

  useEffect(() => {
    async function fetchData() {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "resource/".concat(resourceId, "/", fileName)
      );
      setUrl(response.config.url);
    }

    fetchData();
  }, []);

  const media = fileName.includes(".mp4") ? (
    <video width="320" height="240" controls>
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img src={url} alt="" className="col-md-9" />
  );
  return (
    <React.Fragment>
      <Row className="d-flex justify-content-center">{media}</Row>
      <Row className="d-flex justify-content-center">{displayName}</Row>
    </React.Fragment>
  );
}

export default MediaDisplay;



// WEBPACK FOOTER //
// ./src/views/components/MediaDisplay.jsx